import React, { useState } from 'react';

import './PermissiosAccordion.scss';

interface PermissionAccordionProps {
  heading?: React.ReactNode;
  subHeading?: string;
  withBorder?: boolean;
  innerClass?: string;
  defaultOpen?: boolean;
  actions?: React.ReactNode[];
  headingLevel?: 'xs' | 'sm' | 'md' | 'lg';
  header?: React.ReactNode;
  level?: number;
}

const PermissiosAccordion: React.SFC<PermissionAccordionProps> = (props) => {
  const { defaultOpen, actions, header, heading } = props;
  const [isOpen, setOpen] = useState(defaultOpen || false);
  const onOpen = () => {
    if (!defaultOpen) {
      setOpen(!isOpen);
    }
  };
  const borderClasses = props.withBorder
    ? 'PermissiosAccordion__item--border mb-3'
    : '';
  const innerClass = props.innerClass || '';
  const headingClasses = props.withBorder ? 'p-3' : 'pb-3';
  return (
    <div
      className={`PermissiosAccordion__item ${borderClasses} ${innerClass} `}
    >
      <div
        className={`PermissiosAccordion__heading px-0 py-1 ${headingClasses} `}
        role="presentation"
        onClick={() => onOpen()}
      >
        <div className="PermissiosAccordion__heading-left">
          <div className="row m-0">
            {header}
            <h4
              className={`PermissiosAccordion__title  font-normal font-weight-semibold text-gray-800 ${
                props.headingLevel
                  ? `PermissiosAccordion__title--level-${
                      props.headingLevel || 'md'
                    }`
                  : ''
              }`}
            >
              {heading}
            </h4>
          </div>
        </div>
        <div className="PermissiosAccordion__heading-right align-items-md-center">
          {props.subHeading && (
            <span className="text-muted font-sm font-weight-semibold">
              {props.subHeading}
            </span>
          )}
          {actions &&
            actions.map((action) => <span className="mr-2">{action}</span>)}
          {isOpen && props.level !== 1 && (
            <i className="icon-chevron-up PermissiosAccordion__icon" />
          )}
          {!isOpen && props.level !== 1 && (
            <i className="icon-chevron-down PermissiosAccordion__icon" />
          )}
        </div>
      </div>
      <div
        className={`PermissiosAccordion__collapse permission-timeline-collapse  ${
          isOpen ? 'PermissiosAccordion__collapse--in' : ''
        }`}
        onClick={() => undefined}
      >
        <div className="permission-timeline">{props.children}</div>
      </div>
    </div>
  );
};

export default PermissiosAccordion;
